import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    Stack
} from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

import facilityThumbnailPlaceholder from '../../../facility_thumbnail.jpeg';
import BoltIcon from "@mui/icons-material/Bolt";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PaymentsIcon from "@mui/icons-material/Payments";
import Co2Icon from "@mui/icons-material/Co2";
import CloudIcon from "@mui/icons-material/Cloud";

export default function FacilityCard({ facility, currencySymbol }) {
    const { t } = useTranslation();

    return (
        <Card>
            <CardContent>
                <Stack spacing={2}>
                    <Typography component="h2" variant="h6" color="primary">
                        {facility.name}
                    </Typography>
                    <Box
                        sx={{
                            width: "100%",
                            height: 250,
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 2,
                        }}
                    >
                        <img
                            src={facility.thumbnail ?? facilityThumbnailPlaceholder}
                            alt="Facility thumbnail"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "center"
                            }}
                        />
                    </Box>
                    <Stack spacing={"5pt"}>
                        <Typography variant={"subtitle2"}>
                            {t("Facility savings")}:
                        </Typography>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={12} lg={4}>
                                <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
                                    <PaymentsIcon style={{ fontSize: "25pt" }} />
                                    <Stack alignItems={"center"} spacing={1}>
                                        <Typography variant="h6">
                                            {currencySymbol} {facility.cost?.toLocaleString(undefined, { maximumFractionDigits: 0 }) || "0"}
                                        </Typography>
                                        <Typography variant="body1">
                                            [ {facility.costPercent?.toLocaleString(undefined, { maximumFractionDigits: 0 }) || "0"} % ]
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={4}>
                                <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
                                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                                        <CloudIcon style={{ fontSize: "25pt" }} />
                                        <Co2Icon
                                            style={{ fontSize: "20pt" }}
                                            sx={{
                                                position: "absolute",
                                                top: 3,
                                                left: 3,
                                                color: "white",
                                            }}
                                        />
                                    </Box>
                                    <Stack alignItems={"center"} spacing={1}>
                                        <Typography variant="h6">
                                            {facility.co2?.toLocaleString(undefined, { maximumFractionDigits: 0 }) || "0"} kg
                                        </Typography>
                                        <Typography variant="body1">
                                            [ {facility.co2Percent?.toLocaleString(undefined, { maximumFractionDigits: 0 }) || "0"} % ]
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={4}>
                                <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
                                    <BoltIcon style={{ fontSize: "25pt" }} />
                                    <Stack alignItems={"center"} spacing={1}>
                                        <Typography variant="h6">
                                            {facility.kwh?.toLocaleString(undefined, { maximumFractionDigits: 0 }) || "0"} kWh
                                        </Typography>
                                        <Typography variant="body1">
                                            [ {facility.kwhPercent?.toLocaleString(undefined, { maximumFractionDigits: 0 }) || "0"} % ]
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Grid>

                        </Grid>

                    </Stack>


                </Stack>

            </CardContent>
        </Card>
    );
}
